<template>
  <section
    v-if="Object.keys(pricing).length"
    id="pengumuman-list"
  >
    <!-- title text and switch button -->
    <div class="text-center">
      <h1 class="mt-2 mb-5">
        Pengumuman Terkini
      </h1>
    </div>
    <!--/ title text and switch button -->
  <b-card
    align="center"
  >
    <!-- pricing plan cards -->
    <b-row class="pricing-card mt-5">
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto"
      >
        <b-row>
          <b-col md="6">
            
              <!-- img -->
              <b-img
                v-if="pricing.basicPlan.img"
                :src="pricing.basicPlan.img"
                class="mb-2"
                alt="basic svg img"
              />
              <!--/ img -->
              <b-card-text>
                  11 September 2023
                </b-card-text>
               <h3>Pengumuman Seleksi Masuk Gelombang 2 Program Studi Psikologi Terapan TA 2023-2024</h3>
 
              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                class="mt-2 mb-2"
                variant="warning"
                @click="goToDetail"
              >
                Selengkapnya
              </b-button>
            
          </b-col>
          <b-col md="6">
              <!-- img -->
              <b-img
                v-if="pricing.standardPlan.img"
                :src="pricing.standardPlan.img"
                class="mb-2"
                alt="svg img"
              />
              <!--/ img -->
              <b-card-text>8 September 2023</b-card-text>
              <h3>Informasi Jadwal Seleksi SIMAK UI Tahap 2 Program Studi Psikologi Program Magister (S2 SAINS) Tahun Akademik 2023/2024, Gelombang 2</h3>

              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                class="mt-2 mb-2"
                variant="warning"
                @click="goToDetail"
              >
                Selengkapnya
              </b-button>
          </b-col>
          <b-col md="6">
            
              <!-- img -->
              <b-img
                v-if="pricing.enterprisePlan.img"
                :src="pricing.enterprisePlan.img"
                class="mb-2"
                alt="enterprise svg img"
              />
              <!--/ img -->
              <b-card-text>30 Agustus 2023</b-card-text>
              <h3>Informasi Perubahan Jadwal Seleksi SIMAK UI Tahap 2 Program Studi Psikologi Program Magister (S2 Sains) Tahun Akademik 2023/2024 Gelombang 1</h3>
              
              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                class="mt-2 mb-2"
                variant="warning"
                @click="goToDetail"
              >
                Selengkapnya
              </b-button>
          </b-col>
  <b-col md="6">
            
                <!-- img -->
                <b-img
                  v-if="pricing.enterprisePlan.img"
                  :src="pricing.enterprisePlan.img"
                  class="mb-2"
                  alt="enterprise svg img"
                />
                <!--/ img -->
                <b-card-text>28 Agustus 2023</b-card-text>
                <h3>Pengumuman Seleksi Masuk Tahap 2 Program Studi Doktor Gel.2 TA 2023-2024</h3>
              
                <!-- buttons -->
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  class="mt-2 mb-2"
                  variant="warning"
                  @click="goToDetail"
                >
                  Selengkapnya
                </b-button>
            </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
    <!--/ pricing plan cards -->
  </section>
</template>

<script>
import {
  BFormCheckbox, BRow, BCol, BCard, BImg, BCardText, BListGroup, BListGroupItem, BButton, BBadge,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Ripple from 'vue-ripple-directive'
/* eslint-disable global-require */
export default {
  components: {
    BFormCheckbox,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    AppCollapseItem,
    AppCollapse,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      status: 'monthly',
      monthlyPlanShow: true,
      pricing: {},
    }
  },
  created() {
    this.$http.get('/pricing/data').then(res => { this.pricing = res.data })
  },
  methods: {
    methods: {
      goToDetail() {
        // Use this.$router.push to navigate to a specific route
        this.$router.push({ name: 'pengumuman-detail' });
      }
    }
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
